<template lang="pug">
#job-view
  .banner.bg-cover.hidden-xs
  second-menu(:tabs="tabs", :synctab.sync="selectedTab")
  div.select-company(v-show="selectCompanyToggle")
    div.close-company(@click.prevent="closeSelectCompany()")
      | &times;
    div.select-company-list
      div.company(v-for="company in companies", @click.prevent="selectCompany(company)") {{company.name | multilang}}
  #job-view-content
    router-view
</template>

<script>
import  router from './../../router'
import Uri from 'urijs'
import axios from 'axios'
import Vue from 'vue'
import SecondMenu from '../second-menu.vue'

let tabs = [
  {
    title: window.wordDict.JOB_ALL,
    id: 'all',
  },
  {
    title: window.wordDict.JOB_TECHNOLOGY,
    id: 'technology',
  },
  {
    title: window.wordDict.JOB_NS_MEDIA,
    id: 'media',
  },
  {
    title: window.wordDict.JOB_EL,
    id: 'entertainment',
  },
  {
    title: window.wordDict.JOB_FB,
    id: 'food',
  },
  {
    title: window.wordDict.JOB_BY_COMPANY,
    id: 'company',
  },
]


export default {
  data () {
    return {
      selectedTab: Uri().segment(1),
      tabs,
      oldTab: '',
      companies: [],
      selectCompanyToggle: false,
      selectedCompany: null,
    }
  },
  created () {
    axios.get('/api/companies', {params: {hits:1000}})
    .then((response) => {
      const data = response.data
      this.companies = _.sortBy(response.data.results, company => company.name.en);
    }).catch((err) => console.log(err));
  },
  computed: {},
  ready () {
    console.log(this.$route);
    if (!this.selectedTab) {
      this.selectedTab = 'all';
    }
  },
  watch: {
    selectedTab(newVal, oldVal) {
      if (newVal!='company') {
        if (oldVal=='company') {
          $('#job-view a.mdl-tabs__tab:last-of-type').text(window.wordDict.JOB_BY_COMPANY);
        }
        this.selectCompanyToggle = false;
        this.selectedCompany = null;
        router.go(`/job/${newVal}`);
      } else {
        this.selectCompanyToggle = true;
      }
      this.oldTab = oldVal;
    },
  },
  methods: {
    closeSelectCompany() {
      this.selectCompanyToggle = false;
      this.selectedTab = this.oldTab;
    },
    selectCompany(company) {
      let selected = _.find(this.companies, c => c.company_id==company.company_id);
      this.selectedCompany = selected.name
      $('#job-view a.mdl-tabs__tab:last-of-type').text(Vue.filter('multilang')(selected.name));
      this.selectCompanyToggle = false;
      router.go(`/job/company/${company.company_id}`);
    },
  },
  components: {
    SecondMenu
  }
}
</script>

<style lang="scss" scoped>
@import "global";
.container {
  position: relative;
}
.banner {
  height: 400px;
  padding-bottom: 20%;
  margin-bottom: 40px;
  background-attachment: fixed;
  background-image: url('../../images/job/Half_4_career.jpg');
}

.select-company {
  position: absolute;
  right: 0;
  width: 500px;
  background-color: #003471;
  color: white;
  text-align: left;
  height: 300px;
  z-index: 100;
  .select-company-list {
    position: absolute;
    top: 56px;
    bottom: 30px;
    left: 0;
    right: 0;
    padding: 0 4px;
    overflow-y: scroll;
    .company {
      padding: 16px 12px;
      border-bottom: 1px solid white;
      cursor: pointer;
    }
    .company:last-of-type {
      border-bottom: 0;
    }
  }
  @media(max-width: $grid-float-breakpoint-max) {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    z-index: 9999;
  }
}
.close-company {
  position: absolute;
  z-index: 101;
  right: 50px;
  top: 50px;
  font-size: 32px;
  line-height: 1;
  color: white;
  // border: 1px solid white;
  // border-radius: 30px;
  margin-top: -30px;
  margin-right: -30px;
  padding: 1px 5px;
  cursor: pointer;
}
#job-view-content {
  margin-top: $responsive-mdl-selector-height + 1px;
}
</style>



// WEBPACK FOOTER //
// job-page.vue?8713816e